import { render, staticRenderFns } from "./SalemanChartDayReport.vue?vue&type=template&id=2a7456d1&scoped=true&"
import script from "./SalemanChartDayReport.vue?vue&type=script&lang=js&"
export * from "./SalemanChartDayReport.vue?vue&type=script&lang=js&"
import style0 from "./SalemanChartDayReport.vue?vue&type=style&index=0&id=2a7456d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7456d1",
  null
  
)

export default component.exports